<template>
  <div class="search-helps text-secondary">
    <div class="d-flex align-items-center text-normal-1">
      <link-button class="p-0 text-normal-1 surprise-me" :underline="true" @click="onFeelingLucky"
        >Surprise me</link-button
      >
      <link-button id="select-prompt" class="p-0 ml-2 text-normal-1" :underline="true"
        >See examples</link-button
      >
      <prompts-list :prompts="prompts" @select="onPromptSelection" />
    </div>
  </div>
</template>
<script>
import LinkButton from '@/components/buttons/LinkButton.vue'
import PromptsList from '@/components/templates/PromptsList.vue'
import pickAtRandomFromArray from '@/utils/pickAtRandomFromArray'

const OKR_CREATION_PROMPTS = [
  'Create OKRs for a marketing team that is trying to improve NPS Score',
  'Create OKRs to help us Reach 100k visitors/month via technical and non-technical SEO',
  'Create OKRs to help us Increase the number of monthly blog subscribers 2x',
  'Create OKRs for a advertising agency that wants to Grow their global business and expand into new markets',
  'Create OKRs for a product team that is trying to improve its product retention',
  'Create OKRs for a product team that is trying to improve its sign ups conversion and onboarding flow'
]
const OKR_CREATION_EXTRA_PROMPTS = [
  'Create OKRs to lead a healthy lifestyle and become fit',
  'Create OKRs for a 25 year old to become financially independent by the age of 40',
  'Create OKRs for a family of four to become healthy and fit in a fun way',
  'Create OKRs to help me Run a 10K in under 50 minutes in 3 months'
]

/**
 * This helps users generate prompts for OKR creation
 */
export default {
  name: 'search-helps',
  components: { LinkButton, PromptsList },
  props: {
    onPromptSelection: {}
  },
  data() {
    return {
      prompts: OKR_CREATION_PROMPTS,
      allPrompts: [...OKR_CREATION_PROMPTS, ...OKR_CREATION_EXTRA_PROMPTS]
    }
  },
  methods: {
    onFeelingLucky() {
      const prompt = pickAtRandomFromArray(this.allPrompts)
      this.onPromptSelection(prompt)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.surprise-me:after {
  @include dimension(4px, 4px);
  content: ' ';
  display: inline-block;
  background-color: $secondary;
  border-radius: 50%;
  margin-left: 8px;
  transform: translateY(-3px);
}
.search-helps {
  display: flex;
  justify-content: center;
}
</style>
